import LicenceRenderer from "@/components/ui/table-renderer/LicenceRenderer.vue";
import DateRenderer from "@/components/ui/table-renderer/DateRenderer.vue";
import StringTruncated from "@/components/ui/table-renderer/StringTruncated.vue";
import UppercasedStringRenderer from "@/components/ui/table-renderer/UppercasedStringRenderer.vue";
import EventTypeRenderer from "./table-renderer/EventTypeRenderer.vue";
import EventStateRenderer from "./table-renderer/EventStateRenderer.vue";
import ProfileEventTypeRenderer from "./table-renderer/ProfileEventTypeRenderer.vue";

export const getLicenceHistoryColumns = (window) => {
    return [
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "date",
            label: window.V.$i18n.t("reports.logsTable.columns.date"),
            renderer: DateRenderer,
            activeSort: '-',
            width: "140px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "type",
            label: window.V.$i18n.t("reports.logsTable.columns.event"),
            renderer: EventTypeRenderer,
            filter: {
                type: 'list',
                values: [
                    {
                        id: 'sending',
                        label: window.V.$i18n.t("reports.logsTable.events.sending.label")
                    },
                    {
                        id: 'cancel',
                        label: window.V.$i18n.t("reports.logsTable.events.cancel.label")
                    },
                    {
                        id: 'expired',
                        label: window.V.$i18n.t("reports.logsTable.events.expired.label")
                    },
                    {
                        id: 'association',
                        label: window.V.$i18n.t("reports.logsTable.events.association.label")
                    },
                    {
                        id: 'dissociation',
                        label: window.V.$i18n.t("reports.logsTable.events.dissociation.label")
                    },
                    {
                        id: 'diagnostic',
                        label: window.V.$i18n.t("reports.logsTable.events.diagnostic.label")
                    },
                    {
                        id: 'diagnostic_auto',
                        label: window.V.$i18n.t("reports.logsTable.events.diagnostic_auto.label")
                    },
                    {
                        id: 'permissions',
                        label: window.V.$i18n.t("reports.logsTable.events.permissions.label")
                    }
                ]
            },
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "event_state",
            label: window.V.$i18n.t("reports.logsTable.columns.state"),
            renderer: EventStateRenderer,
            // filter: {
            //     type: 'text'
            // },
            width: "80px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "dati_id",
            label: window.V.$i18n.t("reports.logsTable.columns.licence"),
            renderer: LicenceRenderer,
            filter: {
                type: 'text'
            },
            width: "130px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "dati_name",
            label: window.V.$i18n.t("reports.logsTable.columns.worker"),
            renderer: StringTruncated,
            filter: {
                type: 'text'
            },
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "user_name",
            label: window.V.$i18n.t("reports.logsTable.columns.user"),
            renderer: StringTruncated,
            filter: {
                type: 'text'
            },
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "dati_number",
            label: window.V.$i18n.t("reports.logsTable.columns.phone_number"),
            filter: {
                type: 'text'
            },
            width: "160px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "dati_device",
            label: window.V.$i18n.t("reports.logsTable.columns.phone_model"),
            renderer: UppercasedStringRenderer,
            filter: {
                type: 'text'
            },
            width: "200px"
        }
    ]
};

export const getProfileHistoryColumns = (window) => {
    return [
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "date",
            label: window.V.$i18n.t("reports.logsTable.columns.date"),
            renderer: DateRenderer,
            activeSort: '-',
            width: "140px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "type",
            label: window.V.$i18n.t("reports.logsTable.columns.event"),
            renderer: ProfileEventTypeRenderer,
            filter: {
                type: 'list',
                values: [
                    {
                        id: 'created',
                        label: window.V.$i18n.t("reports.logsTable.profileEvents.created")
                    },
                    {
                        id: 'updated',
                        label: window.V.$i18n.t("reports.logsTable.profileEvents.updated")
                    },
                    {
                        id: 'deleted',
                        label: window.V.$i18n.t("reports.logsTable.profileEvents.deleted")
                    },
                ]
            },
            width: "80px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "user_name",
            label: window.V.$i18n.t("reports.logsTable.columns.user"),
            filter: {
                type: 'text'
            },
            width: "130px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "tracking_id",
            label: window.V.$i18n.t("reports.logsTable.columns.profile_id"),
            filter: {
                type: 'text'
            },
            width: "130px"
        },
        {
            activeSort: false,
            sortable: true,
            showPopup: false,
            key: "name",
            label: window.V.$i18n.t("reports.logsTable.columns.profile_name"),
            filter: {
                type: 'text'
            },
            width: "130px"
        }
    ]
}